import React from 'react';
export function BackgroundFX() {
  // Static, GPU-friendly background. No animations, no large blur filters,
  // no per-frame paints. Everything below is composited once.
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-24">
      {/* Diagonal gradient sweep — static */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/[0.01] via-transparent to-black/[0.4]" data-id="element-25" />

      {/* Dot grid pattern — static */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(#F5B942 1.5px, transparent 1.5px)',
      backgroundSize: '32px 32px'
    }} data-id="element-26" />

      {/* Static gold ambient glow — top-left. Uses radial-gradient (cheap)
              instead of a giant blurred element. */}
      <div className="absolute -top-[20%] -left-[10%] w-[60vw] h-[60vw] opacity-[0.07]" style={{
      background: 'radial-gradient(circle, rgba(245,185,66,1) 0%, rgba(245,185,66,0) 70%)'
    }} data-id="element-27" />

      {/* Static green ambient glow — middle-right */}
      <div className="absolute top-[30%] -right-[15%] w-[50vw] h-[50vw] opacity-[0.05]" style={{
      background: 'radial-gradient(circle, rgba(0,230,118,1) 0%, rgba(0,230,118,0) 70%)'
    }} data-id="element-28" />

      {/* Bottom horizon glow — static */}
      <div className="absolute bottom-0 left-0 right-0 h-[25vh] opacity-[0.06]" style={{
      background: 'linear-gradient(to top, rgba(0,230,118,0.4) 0%, rgba(0,230,118,0) 100%)'
    }} data-id="element-29" />
    </div>;
}